import { IonAlert, IonButton, IonIcon, IonInput, IonItem, IonSpinner, IonTextarea } from '@ionic/react';
import { alertCircleOutline, checkmarkCircle, chevronForwardOutline, closeOutline, pencilOutline } from 'ionicons/icons';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Incrementer from '../../components/incrementer';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import OrderContent from '../../components/orderContent';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { capitalize, deepCopy, forwardTo, getDefaultRoute, getLocale, go, goBack, isDefined, isEmptyObject, isWebConfig, validateForm, validateProfileData, sendToAnalytics, formatBasketItemForAnalytics, getAnalyticsCurrency, roundAnalyticsMoney } from '../../lib/utils';
import { ApplyPoints } from '../../screens/applyPoints';
import { getGiftCards, getVouchers, loading, restoreAuth, sendVoucherCode, setCommonProp, setModal, setProtectedReferrer, showToast } from '../../store/actions';
import MobileInput from '../../components/mobileInput';


import PointsReedemBox from '../../components/pointsReedemBox';
import GiftCardsCheckout from '../../components/giftCardsCheckout';
import AgeRestrictionWarning, { isAgeRestrictionSatisfied } from '../../components/ageRestrictionWarning';
import MinimumOrderBanner from '../../components/minimumOrderBanner';
import Mobiscroll from '../../components/mobiscroll';
import { ReactComponent as LocationIcon } from '../../assets/images/distance.svg';
import { ReactComponent as TimeIcon } from '../../assets/images/acute.svg';
import { ReactComponent as TableIcon } from '../../assets/images/picnic-table.svg';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import { ReactComponent as DiscountIcon } from '../../assets/images/discount.svg';

const { SelectOption } = Mobiscroll;
import './index.css';
import { Capacitor } from '@capacitor/core';
import { GET_TAX } from '../../store/constants';
import VoucherCodeInput from '../../components/voucherCodeInput';
import FieldWrapper from '../../components/fieldWrapper';
import SquarePayButtons from '../../components/squarePayButtons';
import CheckoutPayButtons from '../../components/checkoutPayButtons';
import api from '../../lib/api';

const isWeb = () => Capacitor.getPlatform() === 'web';
const referrer = isWebConfig() ? '/order' : '/order-summary';

const {
	getOrderDate,
	changeItemQuantity,
	itemsCount,
	getItems,
	setMobile,
	getMobile,
	getAllergen,
	getTotal,
	isMinimumOrderTotalSatisfied,
	getMobileValue,
	getMobileCode,
	setMobileValue,
	setMobileCode
} = Basket;

class OrderSummaryRaw extends React.Component {
	constructor(props) {
		super(props);
		this.voucherCodeInput = React.createRef()
		const profile = this.props.profile;

		if (profile && profile.mobile_value && !getMobileValue()) {
			setMobileValue(profile.mobile_value);
		}
		if (profile && profile.mobile_code && !getMobileCode()) {
			setMobileCode(profile.mobile_code);
		}
		if (profile && profile.mobile && !getMobile()) {
			setMobile(profile.mobile);
		}
		this.basketMobileRef = React.createRef()
		this.state = {
			quantityModal: null,
			allergenModal: { isOpen: false, fromCheckoutBtn: false },
			applyPointsModalOpen: false,
			mobile: getMobile() || '',
			email: profile && !profile?.is_guest && profile.email ? profile.email : '',
			customFieldValue: Basket.getCustomFieldValue()?.field_value || '',
			customFieldName: Basket.getCustomFieldValue()?.field_name || '',
			collectedModal: false,
			mobile_code: getMobileCode() ? getMobileCode() : this.props.profile.mobile_code ? this.props.profile.mobile_code : null,
			mobile_value: getMobileValue() ? getMobileValue() : this.props.profile.mobile_value ? this.props.profile.mobile_value : this.props.profile.mobile == this.props.profile.mobile_code ? '' : this.props.profile.mobile,
			openedGiftCards: [],
			openedGiftCardIds: [],
			applyVoucherCodeVisible: false,
			mobileRequired: !this.props.auth.loggedIn
				? false
				: isDefined(getConfig().general.validationConfig?.mobile)
					? getConfig().general.validationConfig?.mobile
					: this.props.auth.loggedIn
						? Basket.getOrderType() !== 'Table' || (getConfig().general.tableRequiredFields || []).filter((el) => el === 'mobile').length > 0
						: false,
			firstNameRequired: isDefined(getConfig().general.validationConfig?.first_name) ? getConfig().general.validationConfig?.first_name : true,
			driverNotes: Basket.getDeliveryAddress()?.notes || '',
			openVouchersPage: false,
			driverModal: false,
			collectedModal: false,
			vouchersLoading: false,
			ageRestrictionError: false
		};
	}
	translateAllergens = (allergensCodes) => {
		let locale = getLocale(this.props.profile);
		let allergensData = [];
		if (allergensCodes.length > 0) {
			allergensData = allergensCodes.map((allergen) => {
				const allergenData = this.props?.allergens?.data?.find((el) => el.code == allergen);
				const translation = allergenData?.translations && allergenData?.translations?.find((translation) => translation.locale == locale);
				if (translation) {
					return translation.text;
				} else {
					return allergen;
				}
			});
		}
		return allergensData;
	};

	getAutomaticAppliedVoucher = async () => {
		try {
			if (!(Basket.applicable_vouchers?.length > 0)) {
				let applicableVouchers;
				let response;
				if (Basket.tax_breakdown.length > 0) {
					if (Basket.has_multi_basket) {
						response = await api.checkMultiBasketDiscountWithTaxes(Basket.parseBasketForMultiBasketCheckVouchers(true));
					} else {
						response = await api.checkDiscountWithTaxes(Basket.parseBasketForCheckVouchers(true));
					}
				} else {
					if (Basket.has_multi_basket) {
						response = await api.checkMultiBasketDiscount(Basket.parseBasketForMultiBasketCheckVouchers());
					} else {
						response = await api.checkDiscount(Basket.parseBasketForCheckVouchers());
					}
				}
				applicableVouchers = response?.data.data || []
				applicableVouchers.sort((a, b) => (b.cost || 0) - (a.cost || 0));

				this.props.dispatch(setCommonProp('applicableVouchers', applicableVouchers))
				const applicableVoucher = applicableVouchers[0]
				const appliedVoucher = this.props.vouchers?.find((voucher) => voucher?.id === applicableVoucher?.id);
				if (appliedVoucher && applicableVoucher) {
					Basket.applyPoints(0);
					Basket.addVoucher(appliedVoucher, applicableVoucher);
				}
			}
		} catch (err) {
			console.log(err)
		}
	}

	componentDidMount() {
		if (this.props.location?.state?.stopLoading) {
			this.props.dispatch(loading(false))

		}
		if (this.props.auth.loggedIn) {
			this.setState({ vouchersLoading: true }, () => {
				this.props.dispatch(getGiftCards());
				this.props.dispatch(getVouchers());
				this.setState({ vouchersLoading: false })
				if (getConfig().flags.hasAutomaticAppliedVoucherOnBasket) {
					this.getAutomaticAppliedVoucher()
				}
			})
		}
		this.props.dispatch(setCommonProp('orderSummaryModalOpen', false))
		try {
			const cartItems = Basket.getAllItems();
			const cartValue = cartItems.reduce((sum, basketItem) => sum + ((parseFloat(basketItem.item?.productPrice) || 0) * (basketItem.quantity || 1)), 0);
			sendToAnalytics('view_cart', {
				ecommerce: {
					currency: getAnalyticsCurrency(),
					value: roundAnalyticsMoney(cartValue),
					items: cartItems.map((basketItem) => formatBasketItemForAnalytics(basketItem)),
				},
			});
		} catch (e) { console.log('Error_sending_view_cart_analytics', e); }
		if (this.props.location?.state?.mobileInvalid) {
			const { mobile, mobile_code } = this.state
			if (!mobile || mobile_code == mobile) {
				this.setState({ mobileError: 'Required field' });
				this.props.dispatch(showToast('Mobile is required', 'warning'));

			} else if (!isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
				this.setState({ mobileError: 'Invalid mobile number' });
				this.props.dispatch(showToast('Please input correct mobile number', 'warning'));

			}
		}

		if (Basket.getAppliedPoints() > 0) {
			this.setState({ applyPointsVisible: true })
		}
		const appliedGiftCards = Basket.getAppliedGiftCards().filter((el) => el.value > 0).map((el) => el.id);
		if (appliedGiftCards.length > 0) {
			this.setState({ openedGiftCardIds: appliedGiftCards })
		}
	}
	componentDidUpdate(prevProps) {

		if (this.props.taxCalculated !== prevProps.taxCalculated && this.props.taxCalculated) {
			if (this.state.openVouchersPage) {
				this.setState({ openVouchersPage: false }, () => {
					const isAuth = this.props.auth.loggedIn;
					const valid = validateProfileData(this.props.profile).isValid;

					!isAuth
						? forwardTo('/login')
						: itemsCount() === 0 || !valid
							? dispatch(setModal('isVerfiedModalOpen', true))
							: this.handleApplyLoyaltyModal(true);
				})
			} else {
				setTimeout(() => {
					if (document.querySelector('.pay-buttons-wrapper')) {
						document.querySelector('.pay-buttons-wrapper').scrollIntoView({ inline: 'end' })
					}
				}, 200);
			}

		}
	}


	handleInput = (key, val) => {
		this.setState({ [key]: val });
		setMobile(val);
	};

	backHandler = () => {
		if (this.props.location && this.props.location.state && this.props.location.state.fromItemDetails) {
			// skip item details page when we going back from order summary
			go(-2);
		} else {
			goBack();
		}
	};
	handlePreBuiltPayment = () => {
		const { email, mobile } = this.state;
		if (this.props.driverBookingPending) {
			return
		}

		Basket.setCustomFieldValue({
			field_value: this.state.customFieldValue,
			field_name: this.state.customFieldName,
		});
		const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
		Basket.setUUID(uuid);
		if (getTotal() === 0) {
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label) : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details', { email, mobile }) : Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
				}
			} else {
				if (this.props.auth.loggedIn) {

					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile });

				}
			}

			return;
		}

		if (Basket.getOrderType() === 'Table') {
			const tableRequiredFields = getConfig().general.tableRequiredFields || [];
			if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
				Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
			} else {
				let valid = true;
				for (let i = 0; i < tableRequiredFields.length; i++) {
					if (!this.props.profile[`${tableRequiredFields[i]}`]) {
						valid = false;
						break;
					}
				}
				!valid ? forwardTo('/contact-details', { email, mobile, referrer, stripe: true }) : Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
			}
		} else {
			if (this.props.auth.loggedIn) {

				if (
					(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
					(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
				) {
					Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
					setMobile(this.props.profile.mobile);
				} else {
					forwardTo('/contact-details', { email, mobile, referrer });
				}
			} else {
				forwardTo('/contact-details', { email, mobile, referrer, stripe: true });

			}
		}
	}
	handleYocoSubmit = (allergens = []) => {
		const { email, mobile } = this.state;
		if (this.props.driverBookingPending) {
			return
		}

		Basket.setCustomFieldValue({
			field_value: this.state.customFieldValue,
			field_name: this.state.customFieldName,
		});
		const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
		Basket.setUUID(uuid);
		if (Basket.getOrderType() === 'Table') {
			const tableRequiredFields = getConfig().general.tableRequiredFields || [];
			if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
				Basket.createYocoOrder('yoco');
			} else {
				let valid = true;
				for (let i = 0; i < tableRequiredFields.length; i++) {
					if (!this.props.profile[`${tableRequiredFields[i]}`]) {
						valid = false;
						break;
					}
				}
				!valid ? forwardTo('/contact-details', { email, mobile, referrer, yoco: true }) : Basket.createYocoOrder('yoco');
			}
		} else {
			if (this.props.auth.loggedIn) {

				if (
					(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
					(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
				) {
					Basket.createYocoOrder('yoco');
					setMobile(this.props.profile.mobile);
				} else {
					forwardTo('/contact-details', { email, mobile, referrer });
				}
			} else {
				forwardTo('/contact-details', { email, mobile, referrer, yoco: true });

			}
		}
	};
	validateAgeRestriction = () => {
		const ageRestrictionSatisfied = isAgeRestrictionSatisfied(this.props.profile);
		this.setState({ ageRestrictionError: !ageRestrictionSatisfied });
		return ageRestrictionSatisfied;
	}
	handleOrderCreation = (action) => {
		const allergens = getAllergen() || [];

		const force_allergen = getConfig()?.flags ? getConfig().flags.force_allergen : false;
		if (allergens.length > 0 && force_allergen) {
			this.setState({ allergenModal: { isOpen: true, action } });
			return;
		} else {
			action()
		}
	}
	handleCollectionOrDriverSubmit = (type) => {
		const { email, mobile } = this.state;
		if (this.props.driverBookingPending) {
			return
		}
		if (!isMinimumOrderTotalSatisfied()) {
			isMinimumOrderTotalSatisfied(true);
			return;
		}

		Basket.setCustomFieldValue({
			field_value: this.state.customFieldValue,
			field_name: this.state.customFieldName,
		});
		const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
		Basket.setUUID(uuid);
		if (getTotal() === 0) {
			if (this.props.auth.loggedIn) {
				if (
					(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
					(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
				) {
					Basket.createOrder(type);
				} else {
					forwardTo('/contact-details', { email, mobile });
				}
			} else {
				forwardTo('/contact-details', { email, mobile });
			}
			return;
		}
		if (this.props.auth.loggedIn) {
			if (
				(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
				(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
			) {
				if (Basket.getMobile() == '') {
					setMobile(this.props.profile.mobile);
				}
				Basket.createOrder(type)
			} else {
				forwardTo('/contact-details', { email, mobile });
			}
		} else {
			forwardTo('/contact-details', { email, mobile });

		}


	}
	handleSubmit = (allergens = []) => {
		const { cards } = this.props;
		const { email, mobile } = this.state;
		const force_allergen = getConfig()?.flags ? getConfig().flags.force_allergen : false;
		if (this.props.driverBookingPending) {
			return
		}
		if (!isMinimumOrderTotalSatisfied()) {
			// display toast with flag 'true'
			isMinimumOrderTotalSatisfied(true);
			return;
		}
		if (allergens.length > 0 && force_allergen) {
			this.setState({ allergenModal: { isOpen: true, fromCheckoutBtn: true } });
			return;
		}
		Basket.setCustomFieldValue({
			field_value: this.state.customFieldValue,
			field_name: this.state.customFieldName,
		});
		const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
		Basket.setUUID(uuid);
		if (getTotal() === 0) {
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? Basket.createOrder() : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details', { email, mobile }) : Basket.createOrder();
				}
			} else {
				if (this.props.auth.loggedIn) {

					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						Basket.createOrder();
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile });

				}
			}

			return;
		}
		if (cards && cards.length >= 1) {
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? forwardTo('/checkout') : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details', { email, mobile }) : forwardTo('/checkout');
				}
			} else {
				if (this.props.auth.loggedIn) {
					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						forwardTo('/checkout', {
							giftVoucher: Basket.getDeliveryOption().id === 'gift-vouchers' ? true : false,
						});
						if (Basket.getMobile() == '') {
							setMobile(this.props.profile.mobile);
						}
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile, referrer });
				}
			}
		} else {
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? forwardTo('/checkout') : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details') : forwardTo('/checkout');
				}
			} else {
				if (this.props.auth.loggedIn) {

					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						if (Basket.getMobile() == '') {
							setMobile(this.props.profile.mobile);
						}
						forwardTo('/checkout', {
							giftVoucher: Basket.getDeliveryOption().id === 'gift-vouchers' ? true : false,
						});
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile });

				}
			}
		}
	};

	handleSquareSubmit = (allergens = []) => {
		const { cards } = this.props;
		const { email, mobile } = this.state;
		const force_allergen = getConfig()?.flags ? getConfig().flags.force_allergen : false;
		if (this.props.driverBookingPending) {
			return false;
		}
		if (!isMinimumOrderTotalSatisfied()) {
			isMinimumOrderTotalSatisfied(true);
			return false;
		}
		if (allergens.length > 0 && force_allergen) {
			this.setState({ allergenModal: { isOpen: true, fromCheckoutBtn: true } });
			return false;
		}
		Basket.setCustomFieldValue({
			field_value: this.state.customFieldValue,
			field_name: this.state.customFieldName,
		});
		const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
		Basket.setUUID(uuid);
		if (getTotal() === 0) {
			const providerName = getConfig()?.checkoutPayment?.enabled ? 'checkout_payment' : 'square';
			const defaultPayment = {
				paymentType: providerName,
				paymentWebType: providerName,
				saveCard: false,
				selectedCard: null,
				nonce: null,
				cb: null,
				skipPayment: true
			};
			const createProviderOrder = (paymentData) =>
				getConfig()?.checkoutPayment?.enabled ? Basket.createCheckoutPaymentOrder(paymentData) : Basket.createSquareOrder(paymentData);
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? createProviderOrder(defaultPayment) : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details', { email, mobile }) : createProviderOrder(defaultPayment);
				}
			} else {
				if (this.props.auth.loggedIn) {

					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						createProviderOrder(defaultPayment);
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile });

				}
			}

			return;
		}
		if (cards && cards.length >= 1) {
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? forwardTo('/checkout') : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details', { email, mobile }) : forwardTo('/checkout');
				}
			} else {
				if (this.props.auth.loggedIn) {
					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						forwardTo('/checkout', {
							giftVoucher: Basket.getDeliveryOption().id === 'gift-vouchers' ? true : false,
						});
						if (Basket.getMobile() == '') {
							setMobile(this.props.profile.mobile);
						}
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile, referrer });
				}
			}
		} else {
			if (Basket.getOrderType() === 'Table') {
				const tableRequiredFields = getConfig().general.tableRequiredFields || [];
				if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
					this.props.auth.loggedIn ? forwardTo('/checkout') : forwardTo('/contact-details', { email, mobile });
				} else {
					let valid = true;
					for (let i = 0; i < tableRequiredFields.length; i++) {
						if (!this.props.profile[`${tableRequiredFields[i]}`]) {
							valid = false;
							break;
						}
					}
					!valid ? forwardTo('/contact-details') : forwardTo('/checkout');
				}
			} else {
				if (this.props.auth.loggedIn) {

					if (
						(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
						(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
					) {
						if (Basket.getMobile() == '') {
							setMobile(this.props.profile.mobile);
						}
						forwardTo('/checkout', {
							giftVoucher: Basket.getDeliveryOption().id === 'gift-vouchers' ? true : false,
						});
					} else {
						forwardTo('/contact-details', { email, mobile });
					}
				} else {
					forwardTo('/contact-details', { email, mobile });
					return false;
				}
			}
		}
	};

	handleNativeSubmit = (allergens = []) => {
		const { email, mobile } = this.state;
		const force_allergen = getConfig()?.flags ? getConfig().flags.force_allergen : false;
		if (this.props.driverBookingPending) {
			return
		}
		if (!isMinimumOrderTotalSatisfied()) {
			isMinimumOrderTotalSatisfied(true);
			return;
		}
		if (allergens.length > 0 && force_allergen) {
			this.setState({ allergenModal: { isOpen: true, fromCheckoutBtn: true } });
			return;
		}
		Basket.setCustomFieldValue({
			field_value: this.state.customFieldValue,
			field_name: this.state.customFieldName,
		});
		const uuid = `${this.props.profile.id}_${Date.now()}`;
		Basket.setUUID(uuid);
		if (Basket.getOrderType() === 'Table') {
			const tableRequiredFields = getConfig().general.tableRequiredFields || [];
			if (tableRequiredFields?.length === 0 || !tableRequiredFields) {
				this.props.auth.loggedIn ? Basket.createOrder('NativePayment') : forwardTo('/contact-details', { email, mobile });
			} else {
				let valid = true;
				for (let i = 0; i < tableRequiredFields.length; i++) {
					if (!this.props.profile[`${tableRequiredFields[i]}`]) {
						valid = false;
						break;
					}
				}
				!valid ? forwardTo('/contact-details', { email, mobile }) : Basket.createOrder('NativePayment');
			}
		} else {
			if (this.props.auth.loggedIn) {

				if (
					(!this.state.mobileRequired || (this.state.mobileRequired && (this.props.profile.mobile || Basket.getMobile()))) &&
					(!this.state.firstNameRequired || (this.state.firstNameRequired && this.props.profile.first_name))
				) {
					Basket.createOrder('NativePayment');
				} else {
					forwardTo('/contact-details', { email, mobile });
				}
			} else {
				forwardTo('/contact-details', { email, mobile });

			}
		}
	};

	handleOrderItemClick = (item, index, quantity, restaurant) => {
		changeItemQuantity(index, quantity, false, restaurant);
		// this.setState({ quantityModal: { item, index } });
	};
	updateItemQuantity = () => {
		const { item, index } = this.state.quantityModal;
		if (this.state.quantityModal) {
			changeItemQuantity(index, item.quantity);
			this.setState({ quantityModal: null });
		}
	};

	onIncrementerUpdate = (newQuantity) => {
		this.setState({
			quantityModal: {
				...this.state.quantityModal,
				item: {
					...this.state.quantityModal,
					quantity: newQuantity,
				},
			},
		});
	};
	cancelTaxCalculation = () => {
		const { dispatch } = this.props;
		dispatch(setCommonProp('taxCalculated', false));
		dispatch(setCommonProp('taxContentLoading', false));
		dispatch(setCommonProp('taxCanceled', true));
	};
	showDriverModal = (modalOpen) => {
		this.setState({ driverModal: modalOpen });
	};
	showCollectedModal = (modalOpen) => {
		this.setState({ collectedModal: modalOpen });
	};
	formatDayName = (__, name) => {
		if (name.includes('Today')) {
			name = 'Today'.toLowerCase();
		} else if (name.includes('Tomorrow')) {
			name = 'Tomorrow'.toLowerCase();
		} else {
			name = getOrderDate();
		}
		return `${__(name)}`;
	};
	isRedeemPointsDisabled = () => {
		const { redeemPointsMin } = getConfig().general;
		const { available_balance } = this.props.profile;
		return available_balance < redeemPointsMin ? true : false;
	};

	findSelectedSlot = (dayInWeek, time) => {
		const restaurant = Basket.getRestaurant();
		const selectedDay =
			!isEmptyObject(restaurant) &&
				restaurant.delivery_times_json &&
				!isEmptyObject(restaurant.delivery_times_json) &&
				restaurant.delivery_times_json.slots &&
				!isEmptyObject(restaurant.delivery_times_json.slots)
				? restaurant.delivery_times_json.slots[dayInWeek]
				: null;
		if (selectedDay) {
			const selectedSlot = selectedDay.find((day) => moment(day.start_time, 'HH:mm').format('HH:mm') === moment(time, 'HH:mm a').format('HH:mm'));
			return moment(selectedSlot.start_time, 'HH:mm').format('h:mm a') + ' - ' + moment(selectedSlot.end_time, 'HH:mm').format('h:mm a');
		}
		return null;
	};

	getSquareTaxes = () => {
		Basket.calculateSquareItemsTax()
	}
	getTax() {
		const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
		Basket.setUUID(uuid, true);
		if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
			this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
		} else {
			let data = Basket.has_multi_basket
				? deepCopy(Basket.multi_basket_items)
				: [
					{
						restaurant: { business_location_id: Basket.getRestaurant()?.business_location_id },
						items: Basket.items,
					},
				];
			const additionalData = Basket.getAdditionalTaxData();
			if (additionalData) {
				data.push(additionalData);
			}
			this.props.dispatch({ type: GET_TAX, data, includeAll: true });
		}
	}
	drawContentHeader = (__, deliveryOption, orderType, deliveryAddress) => {
		let dateName = this.formatDayName(
			__,
			moment(Basket.getOrderDate(), 'dddd Do MMMM').calendar(null, {
				sameDay: '[Today]',
				nextDay: '[Tomorrow]',
			}),
		);
		const selectedRestaurant = Basket.getRestaurant();
		if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'pick-up-point') {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon className='fill-label' />
						<StrongText className='text-to-update'>{Basket.getRestauranName()}</StrongText>
					</div>
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'charter-delivery' && !isEmptyObject(deliveryAddress)) {
			return (
				<>
					<div style={{ marginBottom: 'var(--spacer-2)' }}>
						<Title className=' page-title-centered text-to-update'>{__('Delivery details')}</Title>
					</div>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />
							<StrongText className='text-to-update'>{Basket.getRestauranName()}</StrongText>
						</div>
						{this.props.driverBookingPending ? (
							<>
								<div></div>
								<div style={{ display: 'flex', justifyContent: 'space-between' }}>
									<div>
										<div>
											<StrongText>{__('Booking delivery...')}</StrongText>
										</div>
										<Spacer size={0} />

										<SmallText>{__('Allocating an available driver for your order...')}</SmallText>
									</div>
									<div>
										<IonSpinner name={'circular'} style={{ height: '30px', width: '30px' }} />
									</div>
								</div>
							</>

						) : (
							<>
								{this.props.driverBookingMessage ? (
									<><div></div>
										<div>
											<div style={{ display: 'flex', marginRight: 'var(--spacer-2)' }}>
												<IonIcon style={{ height: '25px', width: '25px' }} color="success" icon={checkmarkCircle} />
											</div>
											<div>

												<div>
													<StrongText>{__('Booking delivery...')}</StrongText>
												</div>
												<SmallText>{__('Driver successfully booked')}</SmallText>
											</div>

										</div>
									</>
								) : (
									<>
										<div>
											<NormalText>{__('Delivery to')}</NormalText>
										</div>
										<NormalText>
											{deliveryAddress.addressLine1}, {deliveryAddress.place} {deliveryAddress.postalCode}
										</NormalText>
										<NormalText> {Basket.is_asap ? 'ASAP' : `${dateName} ${__('at')} ${Basket.getOrderTime()}`}</NormalText>
									</>
								)}
							</>
						)}
					</div>
				</>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'table') {
			return (
				<>
					<div style={{ marginBottom: 'var(--spacer-2)' }}>
						<Title className=' page-title-centered text-to-update'>{__('Order to table details')}</Title>
					</div>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />{' '}
							<StrongText className='text-to-update'>{Basket.getRestauranName()}</StrongText>
						</div>
						<div>
							<TableIcon className='fill-label' />{' '}

							<NormalText>{__('Table number')}</NormalText>
							<StrongText className="bold">{Basket.getTableNumber()}</StrongText>
						</div>
					</div>
				</>

			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'scheduled-collection') {
			return (
				<>
					<div style={{ marginBottom: 'var(--spacer-2)' }}>
						<Title className=' page-title-centered text-to-update'>{__('Collection details')}</Title>
					</div>
					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />{' '}
							<StrongText className='text-to-update'>{Basket.getRestauranName()}</StrongText>
						</div>
						<div>
							<TimeIcon className='fill-label' />{' '}

							<NormalText>{__('Collection time')}</NormalText>
						</div>
						<NormalText className="bold">
							{Basket.additional_data?.named_time_slots_data ? (
								<>
									{dateName} {'at'} {Basket.additional_data?.named_time_slots_data}
								</>
							) : (
								<>
									{dateName} {'at'} {Basket.getOrderTime('h:mm a')}
								</>
							)}
						</NormalText>
					</div>
				</>

			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'pick-up-at-counter') {
			return (
				<>
					<div style={{ marginBottom: 'var(--spacer-2)' }}>
						<Title className=' page-title-centered text-to-update'>{__('Pick up at counter details')}</Title>
					</div>
					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />{' '}
							<StrongText className='text-to-update'>{Basket.getRestauranName()}</StrongText>
						</div>
						<div>
							<TimeIcon className='fill-label' />{' '}
							<NormalText>{__('Collection time')}</NormalText>
							<NormalText className="bold">{__('ASAP')}</NormalText>
						</div>
					</div>
				</>

			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'browse-menu' && selectedRestaurant) {
			return (
				<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
					<div>
						<LocationIcon className='fill-label' />{' '}

						<StrongText >{selectedRestaurant.name} &nbsp;</StrongText>
						{selectedRestaurant.browse_menu_json_time_selector > 1 ? (
							<div onClick={() => forwardTo(`/browse-menu?bl_id=${selectedRestaurant.business_location_id}`)}>
								<NormalText className="bold link underlined">{`${__('View other menus')}`}</NormalText>
							</div>
						) : null}
					</div>
					<div>
						<NormalText className="block">{__(selectedRestaurant.address)}</NormalText>
					</div>
					{selectedRestaurant?.distance && (
						<div className="distance-wrapper">
							<IonIcon className="location-icon" icon={location}></IonIcon>
							<NormalText className="block bold-description click-collect-small-description">
								{`${parseFloat(selectedRestaurant.distance.toFixed(2)) == 1 ? selectedRestaurant.distance.toFixed(0) : selectedRestaurant.distance.toFixed(2)} ${__(getDistanceUnit(parseFloat(selectedRestaurant.distance.toFixed(2)) == 1))}`}
							</NormalText>
						</div>
					)}
				</div>
			);
		} else if (!isEmptyObject(deliveryOption) && deliveryOption.id === 'scheduled-delivery') {
			return (
				<>
					<div style={{ marginBottom: 'var(--spacer-2)' }}>
						<StrongText className='text-to-update'>{__('Delivery details')}</StrongText>
					</div>

					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />{' '}

							<StrongText className=" text-to-update">{Basket.getRestauranName()}</StrongText>
						</div>
						<div>
							<NormalText>{__('Delivery to')}</NormalText>
						</div>
						<NormalText className="block">
							{deliveryAddress.addressLine1}, {deliveryAddress.place} {deliveryAddress.postalCode}
						</NormalText>
						<NormalText className="block">
							{dateName} {__('at')} {Basket.getOrderTime('h:mm a')}
						</NormalText>



					</div>
				</>

			);
		} else {
			return (
				<>
					<div style={{ marginBottom: 'var(--spacer-2)' }}>
						<Title className=' page-title-centered text-to-update'>{__('Collection details')}</Title>
					</div>
					<div className={`box-content order-header-content ${Basket.has_multi_basket ? 'multi-order-heder-content' : ''}`}>
						<div>
							<LocationIcon className='fill-label' />

							<StrongText className='text-to-update'>{Basket.getRestauranName()}</StrongText>
							<EditIcon className='fill-label' style={{ margin: 0 }} onClick={() => forwardTo('/click-and-collect', { saveBasket: true })} />

						</div>
						<div>
							<TimeIcon className='fill-label' />{' '}

							<NormalText>{__('Collection time')}</NormalText>
							<NormalText> {Basket.is_asap ? 'ASAP' : `${Basket.getOrderTime('h:mm a')}`}</NormalText>
						</div>
					</div>
				</>
			);
		}
	};
	handleApplyModal = (flag) => {
		const { history, auth } = this.props;
		const isAuth = auth.loggedIn;
		if (!isAuth) {
			this.props.dispatch(setProtectedReferrer(history.location.path));
			this.props.dispatch(restoreAuth());
			forwardTo('/login');
		} else {
			if (isWebConfig()) {
				this.setState({ applyPointsModalOpen: flag });
			} else {
				forwardTo('/apply-points');
			}
		}
	};
	handleApplyLoyaltyModal = () => {
		const { history, auth } = this.props;
		const isAuth = auth.loggedIn;
		if (!isAuth) {
			this.props.dispatch(setProtectedReferrer(history.location.path));
			this.props.dispatch(restoreAuth());
			forwardTo('/login');
		} else {
			forwardTo('/apply-loyalty');
		}
	};
	formatTableNumberForSelect = (selectedRestaurantId) => {
		const { __ } = this.props;
		let arrForSelect = [];
		if (selectedRestaurantId) {
			(this.state.totalTableNumbers || []).map((table, index) => {
				arrForSelect.push({ text: table, value: table });
			});
		}
		return [{ text: __('Select table'), value: null }, ...arrForSelect];
	};
	getCustomFieldForOrderType = () => {
		const custom_field = Basket.getRestaurant()?.custom_field;
		let result = false;
		switch (Basket.order_type) {
			case 'collection':
				result = custom_field?.['collection'];
				break;
			case 'scheduled-collection':
				result = custom_field?.['scheduled-collection'];
				break;
			case 'scheduled-delivery':
				result = custom_field?.['scheduled-delivery'];
				break;
			case 'table':
				result = custom_field?.['table'];
				break;
			case 'charter-delivery':
				result = custom_field?.['charter-delivery'];
				break;
			case 'pick-up-at-counter':
				result = custom_field?.['pick_up_at_counter'];
				break;
		}
		if (isEmptyObject(result)) {
			return false;
		} else {
			return result;
		}
	};
	handlerOfVoucherCode = (e) => {
		const val = e.target.value.toUpperCase();
		this.setState({ voucherCode: val });
	};
	sendCode = () => {
		const { dispatch } = this.props;
		const { voucherCode } = this.state;
		const data = { code: voucherCode.toUpperCase() };
		this.setState({ voucherCode: null });
		dispatch(sendVoucherCode(data, false, true));
	};
	setMobileCode = (mobile_code) => {
		this.setState({ mobile_code, mobile: `${mobile_code}${this.state.mobile_value}` });
		Basket.setMobile(`${mobile_code}${this.state.mobile_value}`);
		Basket.setMobileCode(mobile_code);

	};
	setMobileValue = (mobile_value) => {
		this.setState({ mobile_value, mobile: `${this.state.mobile_code}${mobile_value}` });
		Basket.setMobile(`${this.state.mobile_code}${mobile_value}`);
		Basket.setMobileValue(mobile_value);

	};
	toggleGiftCards = (param, cardId) => {
		this.setState((prevState) => {
			const { openedGiftCards, openedGiftCardIds } = prevState;
			const index = openedGiftCards.indexOf(param);
			let newArray;

			if (index === -1 && !openedGiftCardIds.includes(cardId)) {
				newArray = [...openedGiftCards, param];
			} else {
				newArray = openedGiftCards.filter((item) => item !== param);
			}
			return { openedGiftCards: newArray, openedGiftCardIds: openedGiftCardIds.filter((item) => item !== cardId) };
		});
	};
	onApplyCardValue = (newValue, card) => {
		let appliedGiftCards = Basket.getAppliedGiftCards();
		const selectedCard = appliedGiftCards.find((el) => el.id == card.id);
		if (selectedCard) {
			selectedCard.value = newValue;
		} else {
			appliedGiftCards.push({ id: card.id, value: newValue, isTopUpCard: Number(card.is_topup_card), isEventCard: Number(card.is_event_card), ...(card.qr_code && { qr_code: card.qr_code }) });
		}
		Basket.setAppliedGiftCards(appliedGiftCards);
	};
	changeTableNumber = () => {
		const tablePlan = getConfig().tablePlan || [];
		const tableData = tablePlan.map((zone) => zone.tables.map((table) => ({ value: table.id, text: `Table ${table.table_number}`, group: zone.name }))).flat();
		this.setState({
			changeTableModal: true,
			tableData,
		});
	};
	setDriverNotes(e) {
		this.setState({ driverNotes: e.target.value }, () => {
			Basket.setDeliveryNotes(e.target.value)
		})
	}
	validateBeforeSquarePayGuest = () => {
		if (!this.validateAgeRestriction()) {
			return false;
		}
		const allergens = getAllergen() || [];
		return this.handleSquareSubmit(allergens);
	};
	validateBeforeSquarePay = () => {
		if (!this.validateAgeRestriction()) {
			return false;
		}
		const { mobileRequired, mobile, mobile_code, customFieldValue } = this.state;
		const customFieldData = this.getCustomFieldForOrderType();
		let hasError = false;
		let mobileError = false;

		if (customFieldData && customFieldData.is_required && customFieldValue == '') {
			this.setState({ customFieldError: true });
			hasError = true;
		} else {
			this.setState({ customFieldError: false });
		}

		if (mobileRequired && (!mobile || mobile_code == mobile)) {
			this.setState({ mobileError: 'Required field' });
			mobileError = true;
			hasError = true;
		} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile }))) {
			this.setState({ mobileError: 'Invalid mobile number' });
			mobileError = true;
			hasError = true;
		} else {
			this.setState({ mobileError: false });
		}

		if (mobileError && this.basketMobileRef?.current) {
			this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' });
		}

		if (Basket.allergen_list == null && getConfig().general.allergenList) {
			this.setState({ allergenError: true });
			hasError = true;
			if (!mobileError) {
				const allergenEl = document.querySelector('.checkout-allergens-wrapper');
				if (allergenEl) allergenEl.scrollIntoView({ behavior: 'smooth' });
			}
		} else {
			this.setState({ allergenError: false });
		}

		return !hasError;
	};

	createSquareOrder = (paymentData) => {
		const uuid = `${this.props.profile.id}_${Date.now()}`;
		Basket.setUUID(uuid);
		Basket.createSquareOrder(paymentData);
	};

	createCheckoutPaymentOrder = (paymentData) => {
		const uuid = `${this.props.profile.id}_${Date.now()}`;
		Basket.setUUID(uuid);
		Basket.createCheckoutPaymentOrder(paymentData);
	};

	render() {
		const { __, profile, auth, dispatch } = this.props;
		const { quantityModal, allergenModal, applyPointsModalOpen, mobile, email, mobile_code, mobile_value, voucherCode, applyPointsVisible, mobileRequired, applyVoucherCodeVisible } = this.state;
		const valid = validateProfileData(profile).isValid;
		const allergens = getAllergen() || [];
		const isAuth = auth.loggedIn;
		const customFieldData = this.getCustomFieldForOrderType();
		const isGuest = isEmptyObject(profile) || profile?.is_guest;
		const customPaymentButtons = getConfig()?.customButtons?.payment
		const deliveryOptionId = Basket.getDeliveryOption()?.id;
		const payOrderOnCollection = (getConfig().flags.payTableOrderOnCollection && deliveryOptionId == 'table') || (getConfig().flags.payCollectionOrderOnCollection && (deliveryOptionId == 'collection' || deliveryOptionId == 'scheduled-collection')) || (getConfig().flags.payCounterOrderOnCollection && deliveryOptionId == 'pick-up-at-counter');
		const hideOtherPaymentButtons = payOrderOnCollection && !getConfig().flags.showAllPaymentMethodsOnCheckout;
		const showTopupCard = getConfig().flags.showTopupCardAfterFinalize ? (Basket.has_square_taxes && Basket.getTaxBreakdown().length > 0) || (!Basket.has_square_taxes && (Basket.getTaxBreakdown().length > 0 || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown)) : true;
		const showVouchers = (Basket.has_square_taxes && Basket.getTaxBreakdown().length > 0) || (!Basket.has_square_taxes && (Basket.getTaxBreakdown().length > 0 || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown));
		return (
			<>
				{isWebConfig() && getConfig().flags.removeSidebar ? <div className='two-columns-wrapper'>
					<div className='order-summary-items'>
						<div >

							{this.drawContentHeader(__, Basket.getDeliveryOption(), Basket.getOrderType(), Basket.getDeliveryAddress())}
							<Spacer size={5} />
							{Basket.order_type.includes('delivery') &&
								<div className="input-field-container">
									<StrongText>{__('Driver notes')}</StrongText>

									<IonItem lines="none" className="input-field-wrapper">
										<IonTextarea
											className="okx-font-secondary"
											onIonInput={(e) => this.setDriverNotes(e)}
											required={true}
											type="text"
											pattern="text"
											inputmode="text"
											value={this.state.driverNotes}

										></IonTextarea>
									</IonItem>
								</div>

							}
							{isAuth && (
								<>

									{getConfig().flags.hasMobileCountryCode ? (
										<div className="input-field-container">
											<StrongText className='block text-to-update'>{__('Confirm your contact number')}</StrongText>

											<MobileInput error={__(this.state.mobileError)} mobile_code={mobile_code} mobile_value={mobile_value} setMobileCode={this.setMobileCode} setMobileValue={this.setMobileValue} />

										</div>

									) : (
										<div className="input-field-container">
											<StrongText>{__('Contact Number')}</StrongText>
											<IonItem lines="none" className="input-field-wrapper">
												<IonInput
													className="mobile-field"
													onIonInput={(e) => this.handleInput('mobile', e.target.value)}
													clearInput
													required={true}
													type="tel"
													pattern="tel"
													inputmode="tel"
													onKeyPress={(e) => {
														const reqexFormat = mobile ? '^[0-9]+$' : '^[+0-9]+$';
														let regex = new RegExp(reqexFormat);
														if (regex.test(e.key)) {
															return true;
														}
														e.preventDefault();
														return false;
													}}
													value={mobile}
												>
													{mobile === '' ? <IonIcon icon={pencilOutline} className="contact-number-icon" /> : null}
												</IonInput>
											</IonItem>
											{this.state.mobileError && <FieldError className="field-error" value={__(this.state.mobileError)} />}

										</div>
									)}
								</>
							)}

							{Basket.getDeliveryOption().id === 'pick-up-at-counter' && (
								<>
									<div className="input-field-container ">
										<StrongText>{__('Enter your email address')}</StrongText>
										<IonItem lines="none" className="input-field-wrapper">
											<IonInput
												value={email}
												clearInput={true}
												disabled={!isGuest}
												type="email"
												pattern="email"
												inputmode="email"
												onIonInput={(e) => this.setState({ email: e.target.value })}
											>
												{email === '' ? <IonIcon icon={pencilOutline} className="contact-number-icon" /> : null}
											</IonInput>
										</IonItem>
									</div>
								</>
							)}
							{customFieldData && (
								<div className="input-field-container ">
									<StrongText>{__(customFieldData.field_name)}</StrongText>
									<FieldWrapper error={this.state.customFieldError ? __('Required field') : null}>
										<IonInput
											value={this.state.customFieldValue}
											onIonInput={(e) =>
												this.setState({
													customFieldValue: e.target.value,
													customFieldName: customFieldData.field_name,
												})
											}
										></IonInput>
									</FieldWrapper>
								</div>
							)}

						</div>
						<div >

							{itemsCount() > 0 ? (
								<OrderContent allergenError={this.state.allergenError} showOnlyItems contentTitle={__('Selected items')} showAddItems={true} handleOrderItemClick={this.handleOrderItemClick.bind(this)} />
							) : (
								<>
									<IonItem lines="none">
										<div className="normal-text" style={{ width: '100%', textAlign: 'center' }}>
											{__('No items')}
										</div>
									</IonItem>
									<IonButton color="primary" expand="block" onClick={() => forwardTo('/order')}>
										{__('Add items')}
									</IonButton>
								</>
							)}

						</div>

					</div>

					<div className='order-summary-amount' style={{ overflow: 'hidden' }}>
						<Title className='page-title-centered'>{__('Order summary')}</Title>

						{itemsCount() > 0 && (
							<OrderContent allergenError={this.state.allergenError} showOnlyAmount showAddItems={true} handleOrderItemClick={this.handleOrderItemClick.bind(this)} />
						)}
						<div className="order-summary-additional-buttons-wrapper">

							{getConfig().flags.hasLoyalty && Basket.getDeliveryOption().id !== 'gift-vouchers' && !getConfig().flags.removeRedeemLoyaltyOnCheckout && (
								<>
									{itemsCount() > 0 &&
										<Spacer size={5} />

									}
									<StrongText className='text-to-update'>{__('Loyalty & promos')}</StrongText>
													<Spacer size={1}/>
									
									<>
										{!getConfig().flags.removeVouchersFromBasket && this.props.auth.loggedIn && (
											<IonButton
												onClick={() => {
													if (showVouchers) {
														!isAuth
															? forwardTo('/login')
															: itemsCount() === 0 || !valid
																? dispatch(setModal('isVerfiedModalOpen', true))
																: this.handleApplyLoyaltyModal(true);
													} else {
														this.setState({
															openVouchersPage: true
														}, () => {
															Basket.has_square_taxes ? this.getSquareTaxes() : this.getTax()
														})

													}
												}}
												className={`${itemsCount() === 0 || !valid ? 'disabled' : ''} order-summary-additional-button`}
												expand="block"
												color="primary"
												fill='clear'
												disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedPoints() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
											>


												{this.state.vouchersLoading ?
													<IonSpinner />
													:
													<>
														{getConfig().general?.basketConfig?.availableVouchersIcon ? <img src={getConfig().general.basketConfig.availableVouchersIcon} /> : <DiscountIcon />}

													</>
												}
												<NormalText className='text-to-update'>{`${this.props.vouchers.length} ${this.props.vouchers.length == 1 ? __('available voucher') : __('available vouchers')}`}</NormalText>
												<IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForwardOutline}></IonIcon>
											</IonButton>
										)}
										{getConfig().flags.hasApplyVoucherCodeOnCheckout && this.props.auth.loggedIn && showVouchers && (
											<VoucherCodeInput disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedPoints() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
												showButton voucherAddedModalOpen={this.props.voucherAddedModalOpen}>
												<div className="order-summary-points-wrapper ">
													<IonButton
														disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedPoints() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
														expand="block"
														color="primary"
														fill='clear'

														className='order-summary-additional-button'>
														{getConfig().general?.basketConfig?.redeemVouchersIcon ? <img src={getConfig().general.basketConfig.redeemVouchersIcon} /> : <DiscountIcon />}

														<NormalText className='text-to-update'>{__('Apply voucher code')}</NormalText>
														<IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForwardOutline}></IonIcon>
													</IonButton>



												</div>
											</VoucherCodeInput>


										)}
									</>
									{(profile.available_balance > 0 && this.props.auth.loggedIn && !getConfig().flags.removeLoyaltyPointsFromBasket) && (
										<div className="order-summary-points-wrapper">
											<IonButton

												{...(!applyPointsVisible ? {
													onClick: () => {
														{
															!isAuth
																? forwardTo('/login')
																: itemsCount() === 0 || !valid
																	? dispatch(setModal('isVerfiedModalOpen', true))
																	: this.setState({ applyPointsVisible: !applyPointsVisible }, () => {

																	});
														}
													}
												} : {})}

												className={`${itemsCount() === 0 || !valid ? 'disabled' : ''} order-summary-additional-button`}
												expand="block"
												color="primary"
												fill='clear'

												disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
											>
												{getConfig().general?.basketConfig?.availablePointsIcon ? <img src={getConfig().general.basketConfig.availablePointsIcon} /> : <DiscountIcon />}

												<NormalText className='text-to-update'>{__('Redeem loyalty points')}</NormalText>
												<IonIcon
													{...(applyPointsVisible ? {
														onClick: (e) => {
															this.setState({ applyPointsVisible: false }, () => {
																Basket.applyPoints(0)
															})

														}
													} : {})}

													key={applyPointsVisible ? 'close' : 'open'} style={applyPointsVisible ? { pointerEvents: 'all' } : { height: '18px', width: '18px' }} icon={applyPointsVisible ? closeOutline : chevronForwardOutline}></IonIcon>
											</IonButton>
											{applyPointsVisible && <PointsReedemBox />}
										</div>
									)}
								</>
							)}
						</div>
						{getConfig().flags.hasLoyalty && Basket.getDeliveryOption().id !== 'gift-vouchers' && !getConfig().flags.removeRedeemLoyaltyOnCheckout && showTopupCard && <GiftCardsCheckout />}

						<div className="order-summary-additional-buttons-wrapper">
							{allergens.length > 0 ? (
								<>
									<Spacer size={2} />
									<IonButton
										fill='clear'
										expand="block"
										className="order-summary-additional-button"
										color="dark"
										onClick={() => this.setState({ allergenModal: { isOpen: true, fromCheckoutBtn: false } })}
									>
										<NormalText className='text-to-update'> {__('View allergen information')}</NormalText>
										<IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForwardOutline}></IonIcon>
									</IonButton>

								</>

							) : null}

						</div>
						<Spacer size={5} />
						{itemsCount() > 0 &&
							<div className="flex-min pay-buttons-wrapper">
								<Spacer size={1} />
								{getConfig().frenchDisclaimer?.disclaimerImage && (
									<div className="disclaimer-wrapper">
										<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
									</div>
								)}
								<AgeRestrictionWarning __={__} error={this.state.ageRestrictionError} onConfirmChange={() => this.setState({ ageRestrictionError: false })} />
								<MinimumOrderBanner __={__} />
								{(Basket.has_square_taxes && Basket.getTaxBreakdown().length > 0) || (!Basket.has_square_taxes && (Basket.getTaxBreakdown().length > 0 || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown)) ? (
									<>
										{!hideOtherPaymentButtons && (isWeb() || getConfig()?.prebuildPayment?.showOnNative) && getConfig().prebuildPayment?.isVisible ? (
											<IonButton
												disabled={!isMinimumOrderTotalSatisfied()}
												style={{ marginBottom: '10px' }}
												className="button-uppercase"
												onClick={() => {
													let customFieldError = false;
													let mobileError = false;
													let allergenError = false
													if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
														this.setState({ customFieldError: true });
														customFieldError = true;
													} else {
														this.setState({ customFieldError: false });
														customFieldError = false;
													}
													if (mobileRequired && (!mobile || mobile_code == mobile)) {
														this.setState({ mobileError: 'Required field' });
														mobileError = true;
													} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
														this.setState({ mobileError: 'Invalid mobile number' });
														mobileError = true;
													} else {
														this.setState({ mobileError: false });
														mobileError = false;
													}
													if (Basket.allergen_list == null && getConfig().general.allergenList) {
														allergenError = true
														this.setState({ allergenError: true })
													} else {
														allergenError = false
														this.setState({ allergenError: false })

													}
													const ageRestrictionError = !this.validateAgeRestriction();
													if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
														if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
															this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
															this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																this.handleOrderCreation(() => this.handlePreBuiltPayment(allergens))

															}));
														} else {
															this.handleOrderCreation(() => this.handlePreBuiltPayment(allergens))

														}
													}

												}}
												expand="block"
											>
												{__(getConfig().prebuildPayment?.label)}
											</IonButton>
										) : null}
										{!hideOtherPaymentButtons && getConfig().flags.hasYocoPayment && (

											<IonButton

												disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
												style={{ marginBottom: '10px' }}
												onClick={() => {
													let customFieldError = false;
													let mobileError = false;
													let allergenError = false
													if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
														this.setState({ customFieldError: true });
														customFieldError = true;
													} else {
														this.setState({ customFieldError: false });
														customFieldError = false;
													}
													if (mobileRequired && (!mobile || mobile_code == mobile)) {
														this.setState({ mobileError: 'Required field' });
														mobileError = true;
													} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
														this.setState({ mobileError: 'Invalid mobile number' });
														mobileError = true;
													} else {
														this.setState({ mobileError: false });
														mobileError = false;
													}
													if (Basket.allergen_list == null && getConfig().general.allergenList) {
														allergenError = true
														this.setState({ allergenError: true })
													} else {
														allergenError = false
														this.setState({ allergenError: false })

													}

													const ageRestrictionError = !this.validateAgeRestriction();
													if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
														if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
															this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
															this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																this.handleOrderCreation(() => this.handleYocoSubmit(allergens))

															}));
														} else {
															this.handleOrderCreation(() => this.handleYocoSubmit(allergens))

														}
													}
												}}
												expand="block"
												color='primary'
												className='button-uppercase'
												{...(customPaymentButtons?.yoco && { style: { '--ion-color-primary': customPaymentButtons?.yoco } })}

											>
												{__('Pay With Yoco')}
											</IonButton>
										)}
										{!hideOtherPaymentButtons && getConfig()?.checkoutPayment?.enabled && getConfig()?.checkoutPayment?.showOnWeb ? (
											<>
												{getTotal() !== 0 ? (
													<CheckoutPayButtons
														__={__}
														disabled={false}
														createOrderCb={this.createCheckoutPaymentOrder}
														autoSaveCard={false}
														restaurant={Basket.getRestaurant()}
														hideCardPayment={true}
														onBeforePay={this.props.auth.loggedIn ? this.validateBeforeSquarePay : this.validateBeforeSquarePayGuest}
														hideApplePay={!this.props.auth.loggedIn || getTotal() === 0}
														hideGooglePay={!this.props.auth.loggedIn || getTotal() === 0}
													/>
												) : null}
												<IonButton
													disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
													style={{ marginBottom: '10px' }}
													onClick={() => {
														if (!this.validateBeforeSquarePay()) return;
														this.handleOrderCreation(() => this.handleSquareSubmit(allergens))
													}}
													expand="block"
													color='primary'
													className='button-uppercase'
												>
													{getTotal() === 0 ? __('Checkout') : __('Pay by card')}
												</IonButton>
											</>

										) : null}
										{!hideOtherPaymentButtons && getConfig()?.squarePayment?.enabled && getConfig()?.squarePayment?.showOnWeb ? (
											<>
												{getTotal() !== 0 ? (
													<SquarePayButtons
														__={__}
														disabled={false}
														createOrderCb={this.createSquareOrder}
														autoSaveCard={false}
														restaurant={Basket.getRestaurant()}
														hideCardPayment={true}
														onBeforePay={this.props.auth.loggedIn ? this.validateBeforeSquarePay : this.validateBeforeSquarePayGuest}
														hideApplePay={!this.props.auth.loggedIn || getTotal() === 0}
														hideGooglePay={!this.props.auth.loggedIn || getTotal() === 0}
													/>
												) : null}
												<IonButton
													disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
													style={{ marginBottom: '10px' }}
													onClick={() => {
														if (!this.validateBeforeSquarePay()) return;
														this.handleOrderCreation(() => this.handleSquareSubmit(allergens))
													}}
													expand="block"
													color='primary'
													className='button-uppercase'
												>
													{getTotal() === 0 ? __('Checkout') : __('Pay by card')}
												</IonButton>
											</>

										) : null}
										{!getConfig().flags.paymentDisabled && !hideOtherPaymentButtons ? (<>
											{isWeb() ? (<>
												<IonButton
													disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
													onClick={() => {
														let customFieldError = false;
														let mobileError = false;
														let allergenError = false
														if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
															this.setState({ customFieldError: true });
															customFieldError = true;
														} else {
															this.setState({ customFieldError: false });
															customFieldError = false;
														}
														if (mobileRequired && (!mobile || mobile_code == mobile)) {
															this.setState({ mobileError: 'Required field' });
															mobileError = true;
														} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
															this.setState({ mobileError: 'Invalid mobile number' });
															mobileError = true;
														} else {
															this.setState({ mobileError: false });
															mobileError = false;
														}
														if (Basket.allergen_list == null && getConfig().general.allergenList) {
															allergenError = true
															this.setState({ allergenError: true })
														} else {
															allergenError = false
															this.setState({ allergenError: false })

														}
														const ageRestrictionError = !this.validateAgeRestriction();
														if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
															if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																	this.handleSubmit(allergens);

																}));
															} else {
																this.handleSubmit(allergens);

															}
														}
													}}
													expand="block"
													className={'checkout-btn ' + (!isMinimumOrderTotalSatisfied() ? 'greyed' : '') + 'button-uppercase'}
													color='primary'
													{...(customPaymentButtons?.default && { style: { '--ion-color-primary': customPaymentButtons?.default } })}
												>
													{`${__('Pay')} ${Basket._getTotal(true)}`}
												</IonButton>
											</>) : (<>
												{getConfig().nativePayment?.isVisible && (
													<IonButton
														disabled={!isMinimumOrderTotalSatisfied() || itemsCount() === 0}
														style={{ marginBottom: '10px' }}
														className="button-uppercase"
														onClick={() => {
															let customFieldError = false;
															let mobileError = false;
															let allergenError = false
															if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																this.setState({ customFieldError: true });
																customFieldError = true;
															} else {
																this.setState({ customFieldError: false });
																customFieldError = false;
															}
															if (mobileRequired && (!mobile || mobile_code == mobile)) {
																this.setState({ mobileError: 'Required field' });
																mobileError = true;
															} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																this.setState({ mobileError: 'Invalid mobile number' });
																mobileError = true;
															} else {
																this.setState({ mobileError: false });
																mobileError = false;
															}
															if (Basket.allergen_list == null && getConfig().general.allergenList) {
																allergenError = true
																this.setState({ allergenError: true })
															} else {
																allergenError = false
																this.setState({ allergenError: false })

															}

															const ageRestrictionError = !this.validateAgeRestriction();
															if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
																if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																		this.handleOrderCreation(() => this.handleNativeSubmit())

																	}));
																} else {
																	this.handleOrderCreation(() => this.handleNativeSubmit())

																}
															}
														}}
														color='primary'
														{...(customPaymentButtons?.default && { style: { '--ion-color-primary': customPaymentButtons?.default } })}

														expand="block"
													>
														{__(getConfig().nativePayment?.label)}
													</IonButton>
												)}

											</>)}
										</>) : null}
										{getConfig().flags.paymentDisabled || payOrderOnCollection ? (<>
											<>
												{payOrderOnCollection || ((getConfig().flags.payOnCollection && (Basket.getDeliveryOption()?.id == 'scheduled-collection' || Basket.getDeliveryOption()?.id == 'collection')) || (getConfig().flags.payTableOnCollection && Basket.getDeliveryOption()?.id == 'table') || (getConfig().flags.payCounterOnCollection && Basket.getDeliveryOption()?.id == 'pick-up-at-counter')) ? (
													<IonButton
														disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
														onClick={() => {
															let customFieldError = false;
															let mobileError = false;
															let allergenError = false
															if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																this.setState({ customFieldError: true });
																customFieldError = true;
															} else {
																this.setState({ customFieldError: false });
																customFieldError = false;
															}
															if (mobileRequired && (!mobile || mobile_code == mobile)) {
																this.setState({ mobileError: 'Required field' });
																mobileError = true;
															} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																this.setState({ mobileError: 'Invalid mobile number' });
																mobileError = true;
															} else {
																this.setState({ mobileError: false });
																mobileError = false;
															}
															if (Basket.allergen_list == null && getConfig().general.allergenList) {
																allergenError = true
																this.setState({ allergenError: true })
															} else {
																allergenError = false
																this.setState({ allergenError: false })

															}

															const ageRestrictionError = !this.validateAgeRestriction();
															if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
																if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																		this.handleOrderCreation(() => this.showCollectedModal(true))

																	}));
																} else {
																	this.handleOrderCreation(() => this.showCollectedModal(true))

																}
															}
														}}
														expand="block"
														color="primary"
														className='button-uppercase'
														{...(customPaymentButtons?.collection && { style: { '--ion-color-primary': customPaymentButtons?.collection } })}
													>
														{`${__('Pay On Collection')}`}
													</IonButton>
												) : null}

												{getConfig().flags.payTheDriver && (Basket.getDeliveryOption()?.id === 'delivery' || Basket.getDeliveryOption()?.id === 'charter-delivery') ? (
													<IonButton
														disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
														onClick={() => {
															let customFieldError = false;
															let mobileError = false;
															let allergenError = false
															if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																this.setState({ customFieldError: true });
																customFieldError = true;
															} else {
																this.setState({ customFieldError: false });
																customFieldError = false;
															}
															if (mobileRequired && (!mobile || mobile_code == mobile)) {
																this.setState({ mobileError: 'Required field' });
																mobileError = true;
															} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																this.setState({ mobileError: 'Invalid mobile number' });
																mobileError = true;
															} else {
																this.setState({ mobileError: false });
																mobileError = false;
															}
															if (Basket.allergen_list == null && getConfig().general.allergenList) {
																allergenError = true
																this.setState({ allergenError: true })
															} else {
																allergenError = false
																this.setState({ allergenError: false })

															}

															const ageRestrictionError = !this.validateAgeRestriction();
															if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
																if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																		this.handleOrderCreation(() => this.showDriverModal(true))

																	}));
																} else {
																	this.handleOrderCreation(() => this.showDriverModal(true))

																}
															}

														}}
														expand="block"
														color="primary"
														className='button-uppercase'
														{...(customPaymentButtons?.driver && { style: { '--ion-color-primary': customPaymentButtons?.driver } })}
													>
														{`${__('Pay To The Driver')}`}
													</IonButton>
												) : null}

											</>
										</>) : null}
									</>
								) : (
									<IonButton className='button-uppercase' expand="block" onClick={() => Basket.has_square_taxes ? this.getSquareTaxes() : this.getTax()}>
										{__('Finalize order')}
									</IonButton>
								)}

							</div>
						}
					</div>
				</div> :

					<>
						<div className="box-with-shadow absolute-content flex-row-wrapper summary-wrapper scrollable-y checkout">
							{Basket.getDeliveryOption().id !== 'gift-vouchers' ? (
								<>
									<div className="checkout">
										{this.drawContentHeader(__, Basket.getDeliveryOption(), Basket.getOrderType(), Basket.getDeliveryAddress())}
										<Spacer size={5} />
										{Basket.order_type.includes('delivery') &&
											<div className="input-field-container">
												<StrongText>{__('Driver notes')}</StrongText>

												<IonItem lines="none" className="input-field-wrapper">
													<IonTextarea
														className="okx-font-secondary"
														onIonInput={(e) => this.setDriverNotes(e)}
														required={true}
														type="text"
														pattern="text"
														inputmode="text"
														value={this.state.driverNotes}

													></IonTextarea>
												</IonItem>
											</div>

										}
										{isAuth && (
											<div ref={this.basketMobileRef}>

												{getConfig().flags.hasMobileCountryCode ? (
													<div className="input-field-container">
														<StrongText className='block text-to-update'>{__('Confirm your contact number')}</StrongText>

														<MobileInput error={__(this.state.mobileError)} mobile_code={mobile_code} mobile_value={mobile_value} setMobileCode={this.setMobileCode} setMobileValue={this.setMobileValue} />

													</div>

												) : (
													<div className="input-field-container">
														<StrongText>{__('Contact Number')}</StrongText>
														<IonItem lines="none" className="input-field-wrapper">
															<IonInput
																className="mobile-field"
																placeholder={__('Enter contact number')}
																onIonInput={(e) => this.handleInput('mobile', e.target.value)}
																clearInput
																required={true}
																type="tel"
																pattern="tel"
																inputmode="tel"
																onKeyPress={(e) => {
																	const reqexFormat = mobile ? '^[0-9]+$' : '^[+0-9]+$';
																	let regex = new RegExp(reqexFormat);
																	if (regex.test(e.key)) {
																		return true;
																	}
																	e.preventDefault();
																	return false;
																}}
																value={mobile}
															>
															</IonInput>
														</IonItem>
														{this.state.mobileError && <FieldError className="field-error" value={__(this.state.mobileError)} />}

													</div>
												)}
											</div>
										)}

										{Basket.getDeliveryOption().id === 'pick-up-at-counter' && (
											<>
												<div className="input-field-container ">
													<StrongText>{__('Enter your email address')}</StrongText>
													<IonItem lines="none" className="input-field-wrapper">
														<IonInput
															value={email}
															clearInput={true}
															disabled={!isGuest}
															type="email"
															pattern="email"
															inputmode="email"
															onIonInput={(e) => this.setState({ email: e.target.value })}
														>
															{email === '' ? <IonIcon icon={pencilOutline} className="contact-number-icon" /> : null}
														</IonInput>
													</IonItem>
												</div>
											</>
										)}
										{customFieldData && (
											<div className="input-field-container ">
												<StrongText>{__(customFieldData.field_name)}</StrongText>
												<FieldWrapper error={this.state.customFieldError ? __('Required field') : null}>
													<IonInput
														value={this.state.customFieldValue}
														onIonInput={(e) =>
															this.setState({
																customFieldValue: e.target.value,
																customFieldName: customFieldData.field_name,
															})
														}
													></IonInput>
												</FieldWrapper>
											</div>
										)}

										{itemsCount() > 0 ? (
											<OrderContent allergenError={this.state.allergenError} showAddItems={true} handleOrderItemClick={this.handleOrderItemClick.bind(this)} />
										) : (
											<>
												<IonItem lines="none">
													<div className="normal-text" style={{ width: '100%', textAlign: 'center' }}>
														{__('No items')}
													</div>
												</IonItem>
												<IonButton color="primary" expand="block" onClick={() => forwardTo('/order')}>
													{__('Add items')}
												</IonButton>
											</>
										)}
										<div className="order-summary-additional-buttons-wrapper">

											{getConfig().flags.hasLoyalty && Basket.getDeliveryOption().id !== 'gift-vouchers' && !getConfig().flags.removeRedeemLoyaltyOnCheckout && (
												<>
													<Spacer size={5} />
													<StrongText className='text-to-update'>{__('Loyalty & promos')}</StrongText>
																	<Spacer size={1}/>
													
													<>

														{!getConfig().flags.removeVouchersFromBasket && this.props.auth.loggedIn && (
															<IonButton
																onClick={() => {
																	if (showVouchers) {
																		!isAuth
																			? forwardTo('/login')
																			: itemsCount() === 0 || !valid
																				? dispatch(setModal('isVerfiedModalOpen', true))
																				: this.handleApplyLoyaltyModal(true);
																	} else {
																		this.setState({
																			openVouchersPage: true
																		}, () => {
																			Basket.has_square_taxes ? this.getSquareTaxes() : this.getTax()
																		})

																	}
																}}
																className={`${itemsCount() === 0 || !valid ? 'disabled' : ''} order-summary-additional-button`}
																expand="block"
																color="primary"
																fill='clear'
																disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedPoints() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
															>

																{this.state.vouchersLoading ?
																	<IonSpinner />
																	:
																	<>
																		{getConfig().general?.basketConfig?.availableVouchersIcon ? <img src={getConfig().general.basketConfig.availableVouchersIcon} /> : <DiscountIcon />}

																	</>
																}

																<NormalText className='text-to-update'>{`${this.props.vouchers.length} ${this.props.vouchers.length == 1 ? __('available voucher') : __('available vouchers')}`}</NormalText>
																<IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForwardOutline}></IonIcon>
															</IonButton>
														)}
														{getConfig().flags.hasApplyVoucherCodeOnCheckout && this.props.auth.loggedIn && showVouchers && (

															<VoucherCodeInput disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedPoints() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0} showButton voucherAddedModalOpen={this.props.voucherAddedModalOpen}>

																<div className="order-summary-points-wrapper ">
																	<IonButton
																		disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedPoints() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
																		expand="block"
																		color="primary"
																		fill='clear'

																		className='order-summary-additional-button'>
																		{getConfig().general?.basketConfig?.redeemVouchersIcon ? <img src={getConfig().general.basketConfig.redeemVouchersIcon} /> : <DiscountIcon />}

																		<NormalText className='text-to-update'>{__('Apply voucher code')}</NormalText>
																		<IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForwardOutline}></IonIcon>
																	</IonButton>



																</div>
															</VoucherCodeInput>


														)}
													</>
													{(profile.available_balance > 0 && this.props.auth.loggedIn && !getConfig().flags.removeLoyaltyPointsFromBasket) && (
														<div className="order-summary-points-wrapper">
															<IonButton

																{...(!applyPointsVisible ? {
																	onClick: () => {
																		{
																			!isAuth
																				? forwardTo('/login')
																				: itemsCount() === 0 || !valid
																					? dispatch(setModal('isVerfiedModalOpen', true))
																					: this.setState({ applyPointsVisible: !applyPointsVisible }, () => {

																					});
																		}
																	}
																} : {})}

																className={`${itemsCount() === 0 || !valid ? 'disabled' : ''} order-summary-additional-button`}
																expand="block"
																color="primary"
																fill='clear'

																disabled={Basket.getAppliedGiftCardsValue() > 0 || Basket.getAppliedVoucher().length > 0 || itemsCount() == 0}
															>
																{getConfig().general?.basketConfig?.availablePointsIcon ? <img src={getConfig().general.basketConfig.availablePointsIcon} /> : <DiscountIcon />}

																<NormalText className='text-to-update'>{__('Redeem loyalty points')}</NormalText>
																<IonIcon
																	{...(applyPointsVisible ? {
																		onClick: (e) => {
																			this.setState({ applyPointsVisible: false }, () => {
																				Basket.applyPoints(0)
																			})

																		}
																	} : {})}
																	key={applyPointsVisible ? 'close' : 'open'} style={applyPointsVisible ? { pointerEvents: 'all', } : { height: '18px', width: '18px' }} icon={applyPointsVisible ? closeOutline : chevronForwardOutline}></IonIcon>
															</IonButton>
															{applyPointsVisible && <PointsReedemBox />}
														</div>
													)}
												</>
											)}
										</div>
										{getConfig().flags.hasLoyalty && Basket.getDeliveryOption().id !== 'gift-vouchers' && !getConfig().flags.removeRedeemLoyaltyOnCheckout && showTopupCard && <GiftCardsCheckout />}
										<div className="order-summary-additional-buttons-wrapper">
											{allergens.length > 0 ? (
												<>
													<Spacer size={2} />

													<IonButton
														fill='clear'
														expand="block"
														className="order-summary-additional-button"
														color="dark"
														onClick={() => this.setState({ allergenModal: { isOpen: true, fromCheckoutBtn: false } })}
													>
														<NormalText className='text-to-update'> {__('View allergen information')}</NormalText>
														<IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForwardOutline}></IonIcon>
													</IonButton>

												</>

											) : null}

										</div>
										<Spacer size={5} />

									</div>
								</>
							) : (
								<div>
									<Title className='page-title-centered'>{__('eGift Voucher Summary')}</Title>
									<Spacer size={2} />
									<div className="gift-voucher-order-content-summary box-content" style={{ margin: 0 }}>
										<Subtitle className="bold">
											{Basket.formatPrice(this.props.giftVoucherData?.points_value / 100)} {__('eGift Voucher')}
										</Subtitle>
										<NormalText>
											{__('Recipient')}
											{': '}
											{this.props.giftVoucherData?.recipient_email}
										</NormalText>
										{this.props.giftVoucherData?.send_on_date && (
											<NormalText className="block">
												{__('Send date')}
												{': '}
												{moment(this.props.giftVoucherData?.send_on_date).format('LLLL')}
											</NormalText>
										)}
									</div>
									<Spacer size={2} />

									<OrderContent allergenError={this.state.allergenError} showAddItems={false} />
								</div>
							)}
							{itemsCount() > 0 &&

								<div className="flex-min pay-buttons-wrapper">
									<Spacer size={1} />
									{getConfig().frenchDisclaimer?.disclaimerImage && (
										<div className="disclaimer-wrapper">
											<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
										</div>
									)}
									<AgeRestrictionWarning __={__} error={this.state.ageRestrictionError} onConfirmChange={() => this.setState({ ageRestrictionError: false })} />
									<MinimumOrderBanner __={__} />
									{(Basket.has_square_taxes && Basket.getTaxBreakdown().length > 0) || (!Basket.has_square_taxes && (Basket.getTaxBreakdown().length > 0 || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown)) ? (
										<>
											{!hideOtherPaymentButtons && (isWeb() || getConfig()?.prebuildPayment?.showOnNative) && getConfig().prebuildPayment?.isVisible ? (
												<IonButton
													disabled={!isMinimumOrderTotalSatisfied()}
													style={{ marginBottom: '10px' }}
													className="button-uppercase"
													onClick={() => {
														let customFieldError = false;
														let mobileError = false;
														let allergenError = false
														if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
															this.setState({ customFieldError: true });
															customFieldError = true;
														} else {
															this.setState({ customFieldError: false });
															customFieldError = false;
														}
														if (mobileRequired && (!mobile || mobile_code == mobile)) {
															this.setState({ mobileError: 'Required field' });
															mobileError = true;
														} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
															this.setState({ mobileError: 'Invalid mobile number' });
															mobileError = true;
														} else {
															this.setState({ mobileError: false });
															mobileError = false;
														}
														if (mobileError && this.basketMobileRef?.current) {
															this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' })
														}
														if (Basket.allergen_list == null && getConfig().general.allergenList) {
															allergenError = true
															this.setState({ allergenError: true })
														} else {
															allergenError = false
															this.setState({ allergenError: false })

														}

														const ageRestrictionError = !this.validateAgeRestriction();
														if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
															if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																	this.handleOrderCreation(() => this.handlePreBuiltPayment(allergens))

																}));
															} else {
																this.handleOrderCreation(() => this.handlePreBuiltPayment(allergens))

															}
														}
													}}
													expand="block"
												>
													{__(getConfig().prebuildPayment?.label)}
												</IonButton>
											) : null}
											{!hideOtherPaymentButtons && getConfig().flags.hasYocoPayment && (

												<IonButton

													disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
													style={{ marginBottom: '10px' }}
													onClick={() => {
														let customFieldError = false;
														let mobileError = false;
														let allergenError = false
														if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
															this.setState({ customFieldError: true });
															customFieldError = true;
														} else {
															this.setState({ customFieldError: false });
															customFieldError = false;
														}
														if (mobileRequired && (!mobile || mobile_code == mobile)) {
															this.setState({ mobileError: 'Required field' });
															mobileError = true;
														} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
															this.setState({ mobileError: 'Invalid mobile number' });
															mobileError = true;
														} else {
															this.setState({ mobileError: false });
															mobileError = false;
														}
														if (mobileError && this.basketMobileRef?.current) {
															this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' })
														}
														if (Basket.allergen_list == null && getConfig().general.allergenList) {
															allergenError = true
															this.setState({ allergenError: true })
														} else {
															allergenError = false
															this.setState({ allergenError: false })

														}
														const ageRestrictionError = !this.validateAgeRestriction();
														if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
															if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																	this.handleOrderCreation(() => this.handleYocoSubmit(allergens))

																}));
															} else {
																this.handleOrderCreation(() => this.handleYocoSubmit(allergens))

															}
														}

													}}
													color='primary'
													expand="block"
													className='button-uppercase'
													{...(customPaymentButtons?.yoco && { style: { '--ion-color-primary': customPaymentButtons?.yoco } })}
												>
													{__('Pay With Yoco')}
												</IonButton>
											)}
											{!hideOtherPaymentButtons && getConfig()?.checkoutPayment?.enabled && getConfig()?.checkoutPayment?.showOnNative && (
												<>
													{getTotal() !== 0 ? (
														<CheckoutPayButtons
															__={__}
															disabled={false}
															createOrderCb={this.createCheckoutPaymentOrder}
															autoSaveCard={false}
															restaurant={Basket.getRestaurant()}
															hideCardPayment={true}
															onBeforePay={this.props.auth.loggedIn ? this.validateBeforeSquarePay : this.validateBeforeSquarePayGuest}
															hideApplePay={!this.props.auth.loggedIn}
															hideGooglePay={!this.props.auth.loggedIn}
														/>
													) : null}
													<IonButton
														disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
														style={{ marginBottom: '10px' }}
														onClick={() => {
															if (!this.validateBeforeSquarePay()) return;
															this.handleOrderCreation(() => this.handleSquareSubmit(allergens))
														}}
														expand="block"
														color='primary'
														className='button-uppercase'
													>
														{getTotal() === 0 ? __('Checkout') : __('Pay by card')}
													</IonButton>
												</>
											)}
											{!hideOtherPaymentButtons && getConfig()?.squarePayment?.enabled && getConfig()?.squarePayment?.showOnNative && (
												<>
													{getTotal() !== 0 ? (
														<SquarePayButtons
															__={__}
															disabled={false}
															createOrderCb={this.createSquareOrder}
															autoSaveCard={false}
															restaurant={Basket.getRestaurant()}
															hideCardPayment={true}
															onBeforePay={this.props.auth.loggedIn ? this.validateBeforeSquarePay : this.validateBeforeSquarePayGuest}
															hideApplePay={!this.props.auth.loggedIn}
															hideGooglePay={!this.props.auth.loggedIn}
														/>
													) : null}
													<IonButton
														disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
														style={{ marginBottom: '10px' }}
														onClick={() => {
															if (!this.validateBeforeSquarePay()) return;
															this.handleOrderCreation(() => this.handleSquareSubmit(allergens))
														}}
														expand="block"
														color='primary'
														className='button-uppercase'
													>
														{getTotal() === 0 ? __('Checkout') : __('Pay by card')}
													</IonButton>
												</>
											)}
											{!getConfig().flags.paymentDisabled && !hideOtherPaymentButtons ? (<>
												{isWeb() ? (<>
													<IonButton
														disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
														onClick={() => {
															let customFieldError = false;
															let mobileError = false;
															let allergenError = false
															if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																this.setState({ customFieldError: true });
																customFieldError = true;
															} else {
																this.setState({ customFieldError: false });
																customFieldError = false;
															}
															if (mobileRequired && (!mobile || mobile_code == mobile)) {
																this.setState({ mobileError: 'Required field' });
																mobileError = true;
															} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																this.setState({ mobileError: 'Invalid mobile number' });
																mobileError = true;
															} else {
																this.setState({ mobileError: false });
																mobileError = false;
															}
															if (mobileError && this.basketMobileRef?.current) {
																this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' })
															}
															if (Basket.allergen_list == null && getConfig().general.allergenList) {
																allergenError = true
																this.setState({ allergenError: true })
															} else {
																allergenError = false
																this.setState({ allergenError: false })

															}



															const ageRestrictionError = !this.validateAgeRestriction();
															if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {

																if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																	this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																		this.handleSubmit(allergens);

																	}));
																} else {
																	this.handleSubmit(allergens);

																}
															}
														}}
														expand="block"
														className={'checkout-btn ' + (!isMinimumOrderTotalSatisfied() ? 'greyed' : '') + 'button-uppercase'}
														color='primary'
														{...(customPaymentButtons?.default && { style: { '--ion-color-primary': customPaymentButtons?.default } })}

													>
														{`${__('Pay')} ${Basket._getTotal(true)}`}
													</IonButton>
												</>) : (<>
													{getConfig().nativePayment?.isVisible && (
														<IonButton
															disabled={!isMinimumOrderTotalSatisfied() || itemsCount() === 0}
															style={{ marginBottom: '10px' }}
															className="button-uppercase"
															onClick={() => {
																let customFieldError = false;
																let mobileError = false;
																let allergenError = false
																if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																	this.setState({ customFieldError: true });
																	customFieldError = true;
																} else {
																	this.setState({ customFieldError: false });
																	customFieldError = false;
																}
																if (mobileRequired && (!mobile || mobile_code == mobile)) {
																	this.setState({ mobileError: 'Required field' });
																	mobileError = true;
																} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																	this.setState({ mobileError: 'Invalid mobile number' });
																	mobileError = true;
																} else {
																	this.setState({ mobileError: false });
																	mobileError = false;
																}
																if (mobileError && this.basketMobileRef?.current) {
																	this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' })
																}
																if (Basket.allergen_list == null && getConfig().general.allergenList) {
																	allergenError = true
																	this.setState({ allergenError: true })
																} else {
																	allergenError = false
																	this.setState({ allergenError: false })

																}

																const ageRestrictionError = !this.validateAgeRestriction();
																if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
																	if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																		this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																		this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																			this.handleOrderCreation(() => this.handleNativeSubmit())

																		}));
																	} else {
																		this.handleOrderCreation(() => this.handleNativeSubmit())

																	}
																}
															}}
															color='primary'
															{...(customPaymentButtons?.default && { style: { '--ion-color-primary': customPaymentButtons?.default } })}
															expand="block"
														>
															{__(getConfig().nativePayment?.label)}
														</IonButton>
													)}

												</>)}
											</>) : null}
											{getConfig().flags.paymentDisabled || payOrderOnCollection ? (<>
												<>
													{payOrderOnCollection || ((getConfig().flags.payOnCollection && (Basket.getDeliveryOption()?.id == 'scheduled-collection' || Basket.getDeliveryOption()?.id == 'collection')) || (getConfig().flags.payTableOnCollection && Basket.getDeliveryOption()?.id == 'table') || (getConfig().flags.payCounterOnCollection && Basket.getDeliveryOption()?.id == 'pick-up-at-counter')) ? (
														<IonButton
															disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
															onClick={() => {
																let customFieldError = false;
																let mobileError = false;
																let allergenError = false;
																if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																	this.setState({ customFieldError: true });
																	customFieldError = true;
																} else {
																	this.setState({ customFieldError: false });
																	customFieldError = false;
																}
																if (mobileRequired && (!mobile || mobile_code == mobile)) {
																	this.setState({ mobileError: 'Required field' });
																	mobileError = true;
																} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																	this.setState({ mobileError: 'Invalid mobile number' });
																	mobileError = true;
																} else {
																	this.setState({ mobileError: false });
																	mobileError = false;
																}
																if (mobileError && this.basketMobileRef?.current) {
																	this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' })
																}
																if (Basket.allergen_list == null && getConfig().general.allergenList) {
																	allergenError = true
																	this.setState({ allergenError: true })
																} else {
																	allergenError = false
																	this.setState({ allergenError: false })

																}

																const ageRestrictionError = !this.validateAgeRestriction();
																if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
																	if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																		this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																		this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																			this.handleOrderCreation(() => this.showCollectedModal(true))

																		}));
																	} else {
																		this.handleOrderCreation(() => this.showCollectedModal(true))

																	}
																}
															}}
															expand="block"
															color="primary"
															className='button-uppercase'
															{...(customPaymentButtons?.collection && { style: { '--ion-color-primary': customPaymentButtons?.collection } })}
														>
															{`${__('Pay On Collection')}`}
														</IonButton>
													) : null}

													{getConfig().flags.payTheDriver && (Basket.getDeliveryOption()?.id === 'delivery' || Basket.getDeliveryOption()?.id === 'charter-delivery') ? (
														<IonButton
															disabled={itemsCount() === 0 || !isMinimumOrderTotalSatisfied()}
															onClick={() => {
																let customFieldError = false;
																let mobileError = false;
																let allergenError = false
																if (customFieldData && customFieldData.is_required && this.state.customFieldValue == '') {
																	this.setState({ customFieldError: true });
																	customFieldError = true;
																} else {
																	this.setState({ customFieldError: false });
																	customFieldError = false;
																}
																if (mobileRequired && (!mobile || mobile_code == mobile)) {
																	this.setState({ mobileError: 'Required field' });
																	mobileError = true;
																} else if (mobileRequired && !isEmptyObject(validateForm({ mobile: { type: 'tel', required: true } }, { mobile: this.state.mobile }))) {
																	this.setState({ mobileError: 'Invalid mobile number' });
																	mobileError = true;
																} else {
																	this.setState({ mobileError: false });
																	mobileError = false;
																}
																if (mobileError && this.basketMobileRef?.current) {
																	this.basketMobileRef.current.scrollIntoView({ behavior: 'smooth' })
																}
																if (Basket.allergen_list == null && getConfig().general.allergenList) {
																	allergenError = true
																	this.setState({ allergenError: true })
																} else {
																	allergenError = false
																	this.setState({ allergenError: false })

																}

																const ageRestrictionError = !this.validateAgeRestriction();
																if (!mobileError && !customFieldError && !allergenError && !ageRestrictionError) {
																	if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
																		this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
																		this.props.dispatch(setCommonProp('serviceChargeBoxAlertAction', () => {
																			this.handleOrderCreation(() => this.showDriverModal(true))

																		}));
																	} else {
																		this.handleOrderCreation(() => this.showDriverModal(true))

																	}
																}
															}}
															expand="block"
															color="primary"
															className='button-uppercase'
															{...(customPaymentButtons?.driver && { style: { '--ion-color-primary': customPaymentButtons?.driver } })}
														>
															{`${__('Pay To The Driver')}`}
														</IonButton>
													) : null}

												</>
											</>) : null}
										</>
									) : (
										<IonButton className='button-uppercase' expand="block" onClick={() => Basket.has_square_taxes ? this.getSquareTaxes() : this.getTax()}>
											{__('Finalize order')}
										</IonButton>
									)}

								</div>}
						</div>

					</>
				}

				<Modal cssClass="change-table-modal" actionLabel={__('Change')} isOpen={!!this.state.changeTableModal} onDidDismiss={() => this.setState({ changeTableModal: false })}>
					<Title className='modal-title'>{__('Change table')}</Title>
					<Spacer size={2} />
					<SelectOption
						theme='ios'
						cssClass={isWebConfig() ? 'web' : ''}

						inputStyle="box"
						display="inline"
						{...(getConfig().tablePlan && getConfig().tablePlan.length > 1 && { group: { header: true, groupWheel: false, clustered: false } })}
						data={this.state.tableData}
						value={Basket.getTableNumber() || null}
						onSet={(e, a) => Basket.setTableNumber(a.getVal())}
					/>
					<Spacer size={2} />

					<IonButton className='button-uppercase' expand="block" color="primary" onClick={() => this.setState({ changeTableModal: false })}>
						{__('Continue')}
					</IonButton>
				</Modal>
				<Modal
					cssClass="quantity-modal customIncrementModal"
					action={this.updateItemQuantity}
					actionLabel={__('Change')}
					isOpen={!!quantityModal}
					onDidDismiss={() => this.setState({ quantityModal: null })}
					showCancelButton={true}
				>
					<Title >{__('Change quantity')}</Title>
					<Spacer size={2} />
					{quantityModal && quantityModal.item ? <Incrementer allowNegative={false} quantity={quantityModal.item.quantity} onUpdate={this.onIncrementerUpdate} /> : null}
				</Modal>
				<Modal isOpen={allergenModal?.isOpen} onDidDismiss={() => this.setState({ allergenModal: { isOpen: false, fromCheckoutBtn: false } })}>
					<div className=" flex-row-wrapper">
						<Title className='modal-title'>{__('Allergen Information')}</Title>
						<NormalText>{__('Please speak to our staff if you have any concerns about allergies')}</NormalText>
						<Spacer />
						{Basket.has_multi_basket ? (
							<>
								{Basket.multi_basket_items.map((order, orderIndex) => {
									return (
										<React.Fragment key={`order_${orderIndex}`}>
											{order.items.map((item, index) => {
												let data = allergens.find((allergen) => allergen[1].sku === item.item.sku);
												const modifiers = item?.selectedChoices
													?.flat()
													?.map((modifier) => allergens?.find((allergen) => allergen?.[1]?.sku === modifier?.sku))
													?.map((el) => el?.[0]?.allergens)
													.filter(Boolean);
												const modifierAllergens = modifiers?.length > 0 ? [...new Set([...modifiers.flat()])] : [];

												if (data && data.length > 0) {
													const translatedAllergens = this.translateAllergens([...data?.[0]?.allergens, ...modifierAllergens].filter(Boolean));

													return (
														<>
															<div className="box-content" key={`allergen-${orderIndex}-${index}`}>
																<NormalText className="block">
																	{item.quantity}x {Basket.getProductName(item.item, this.props.profile)}
																</NormalText>
																<Spacer size={2} />
																<SmallText className='primary-color'>
																	{[...new Set(translatedAllergens)].map(el => capitalize(el)).join(', ')}
																</SmallText>
															</div>
															<Spacer size={2} />
														</>
													);
												}

												return null;
											})}
										</React.Fragment>
									);
								})}
							</>
						) : (
							<>
								{getItems().map((item, index) => {
									let data = allergens.find((allergen) => allergen[1].sku === item.item.sku);
									const modifiers = item?.selectedChoices
										?.flat()
										?.map((modifier) => allergens?.find((allergen) => allergen?.[1]?.sku === modifier?.sku))
										?.map((el) => el?.[0]?.allergens)
										.filter(Boolean);
									const modifierAllergens = modifiers?.length > 0 ? [...new Set([...modifiers.flat()])] : [];
									if (data && data.length > 0) {
										const translatedAllergens = this.translateAllergens([...data?.[0]?.allergens, ...modifierAllergens].filter(Boolean));

										return (
											<>
												<div className="box-content" key={'allergen-' + index}>
													<NormalText className="block">
														{item.quantity}x {Basket.getProductName(item.item, this.props.profile)}
													</NormalText>
													<Spacer size={2} />

													<SmallText className='primary-color'>
														{[...new Set(translatedAllergens)].map(el => capitalize(el)).join(', ')}
													</SmallText>
												</div>
												<Spacer size={2} />
											</>
										);
									}

									return null;
								})}
							</>
						)}
					</div>
					<Spacer size={5} />
					{allergenModal?.fromCheckoutBtn && (
						<IonButton className='button-uppercase' disabled={itemsCount() === 0} onClick={() => { getConfig()?.squarePayment?.enabled || getConfig()?.checkoutPayment?.enabled ? this.handleSquareSubmit() : this.handleSubmit([]) }} expand="block">
							{__('Accept')}
						</IonButton>
					)}
					{allergenModal?.action && (
						<IonButton className='button-uppercase' disabled={itemsCount() === 0} onClick={() => {
							const action = allergenModal.action;
							this.setState({ allergenModal: { isOpen: false, fromCheckoutBtn: false } }, action);
						}} expand="block">
							{__('Accept')}
						</IonButton>
					)}
					<Spacer size={5} />
					<div className="flex-min centered">
						<IonButton className="link " color="secondary" onClick={() => this.setState({ allergenModal: { isOpen: false, fromCheckoutBtn: false } })}>
							{__('Hide allergen information')}
						</IonButton>
					</div>
				</Modal>
				<Modal cssClass="apply-points-modal" isOpen={applyPointsModalOpen} onDidDismiss={() => this.handleApplyModal(false)}>
					<ApplyPoints handleApplyModal={this.handleApplyModal} applyPointsModalOpen={applyPointsModalOpen} />
				</Modal>
				<Modal
					className="modal-type-alert"
					isOpen={this.props.voucherRemovedModalOpen}
					onDidDismiss={() => this.props.dispatch(setCommonProp('voucherRemovedModalOpen', false))}
				>
					<StrongText className='block'>{__('Important!')}</StrongText>
					<Spacer size={5} />
					<div style={{ display: 'grid', justifyItems: 'center', textAlign: 'center' }}>
						<IonIcon style={{ height: '48px', width: '48px' }} color='primary' icon={alertCircleOutline}></IonIcon>
						<Title className='block'>{__("Voucher removed")}</Title>
						<NormalText className='block'>{__('Your voucher was removed after basket changes. Add it again if needed.')}</NormalText>
					</div>
					<Spacer size={5} />

					<div className='alert-button-group'>
						<IonButton
							color="primary"
							expand="block"
							onClick={() => this.props.dispatch(setCommonProp('voucherRemovedModalOpen', false))}
							className="submit-button"
						>
							{__('Continue')}
						</IonButton>

					</div>
				</Modal>
				<IonAlert
					isOpen={this.state.driverModal}
					onDidDismiss={() => this.showDriverModal(false)}
					header={__('Pay to the Driver')}
					message={__('You agree to pay the driver the amount outstanding on delivery. Earned loyalty will be updated  after payment.')}
					buttons={[
						{
							text: __('Confirm'),
							cssClass: 'primary',
							handler: () => {
								this.setState({ driverModal: false }, () => {
									this.handleCollectionOrDriverSubmit('driverPay')

								})
							},
						},
						{
							text: __('Cancel'),
							role: 'cancel',
							cssClass: 'secondary link',
							handler: () => this.showDriverModal(false),
						},

					]}
				/>
				<IonAlert
					isOpen={this.state.collectedModal}
					onDidDismiss={() => this.showCollectedModal(false)}
					header={__('Pay on Collection')}
					message={__('You agree to pay the amount shown before collecting your order. Earned loyalty will be updated after payment.')}
					buttons={[
						{
							text: __('Confirm'),
							cssClass: 'primary',

							handler: () => {
								this.setState({ collectedModal: false }, () => {
									this.handleCollectionOrDriverSubmit('collectedPay')

								})

							},
						},
						{
							text: __('Cancel'),
							role: 'cancel',
							cssClass: 'secondary link',
							handler: () => this.showCollectedModal(false),
						},

					]}
				/>
				<IonAlert
					backdropDismiss={false}
					isOpen={this.props.taxContentLoading}
					header={__('Calculating taxes')}
					message={`<div class="tax-alert"><ion-spinner ></ion-spinner> <span class="normal-text">${__('Please wait whilst we calculate taxes')}</span></div>`}
					buttons={[
						{
							text: __('Cancel'),
							role: 'cancel',
							cssClass: 'primary',
							handler: () => this.cancelTaxCalculation(),
						},
					]}
				/>
			</>
		);
	}
}

const mapStateToProps = (store) => {
	const { basketUpdated, deliveryOption, giftVoucherData } = store.orders;
	const { auth, giftCards, profile } = store.profile;
	const { driverBookingPending, driverBookingMessage, voucherRemovedModalOpen, voucherAddedModalOpen } = store.common
	const { allergens } = store.restaurants
	return {
		basketUpdated,
		profile: store.profile.profile,
		cards: store.orders.cards || [],
		deliveryOption,
		itemAllergens: store.restaurants.itemAllergens,
		auth,
		giftVoucherData,
		taxCalculated: store.common.taxCalculated,
		taxContentLoading: store.common.taxContentLoading,
		giftCards: giftCards || [],
		vouchers: store.profile.vouchers || [],
		driverBookingPending,
		driverBookingMessage,
		voucherRemovedModalOpen,
		voucherAddedModalOpen,
		profile,
		allergens,
		navConfig: store.common.navConfig

	};
};

export const OrderSummary = connect(mapStateToProps)(withRouter(withTranslation(OrderSummaryRaw)));

class OrderSummaryWrapped extends React.Component {

	componentDidMount() {
		if (Basket.getAllItems().length === 0 && isEmptyObject(Basket.getRestaurant())) {
			const defaultRoute = getDefaultRoute(this.props.navConfig);
			if (defaultRoute?.path) {
				forwardTo(defaultRoute.path);
			}
		}
	}

	backHandler = () => {
		if (this.props.location && this.props.location.state && this.props.location.state.fromItemDetails) {
			// skip item details page when we going back from order summary
			go(-2);
		} else if (this.props.location && this.props.location.state && this.props.location.state.skipBackToThePreviousPage) {
			forwardTo('/order');
		} else {
			goBack();
		}
	};
	render() {
		const { __ } = this.props;
		return (
			<Loading transparent>
				<Layout showLoginIcon={getConfig().flags.hasGuestCheckout} color="transparent" title={__('Checkout')} backHandler={this.backHandler} scrollY={false} headerWithTitle={true}>


					<OrderSummary />
				</Layout>
			</Loading>
		);
	}
}

export default connect(mapStateToProps)(withTranslation(OrderSummaryWrapped));



class OrderSummaryItemsRaw extends React.Component {
	constructor(props) {
		super(props);

		this.state = {

		};
	}

	backHandler = () => {
		if (this.props.location && this.props.location.state && this.props.location.state.fromItemDetails) {
			// skip item details page when we going back from order summary
			go(-2);
		} else {
			goBack();
		}
	};


	handleOrderItemClick = (item, index, quantity, restaurant) => {
		changeItemQuantity(index, quantity, false, restaurant);
	};
	updateItemQuantity = () => {
		const { item, index } = this.state.quantityModal;
		if (this.state.quantityModal) {
			changeItemQuantity(index, item.quantity);
			this.setState({ quantityModal: null });
		}
	};

	onIncrementerUpdate = (newQuantity) => {
		this.setState({
			quantityModal: {
				...this.state.quantityModal,
				item: {
					...this.state.quantityModal,
					quantity: newQuantity,
				},
			},
		});
	};

	render() {
		const { __ } = this.props;
		return (
			<>
				<div className="box-with-shadow absolute-content flex-row-wrapper summary-wrapper scrollable-y checkout">
					{Basket.getDeliveryOption().id !== 'gift-vouchers' ? (
						<>
							<OrderContent allergenError={this.state.allergenError} contentTitle={__('Your order')} showOnlyItems showAddItems={true} handleOrderItemClick={this.handleOrderItemClick.bind(this)} />


						</>
					) : (
						<div>
							<Title className='page-title-centered'>{__('eGift Voucher Summary')}</Title>
							<Spacer size={2} />
							<div className="gift-voucher-order-content-summary box-content" style={{ margin: 0 }}>
								<Subtitle className="bold">
									{Basket.formatPrice(this.props.giftVoucherData?.points_value / 100)} {__('eGift Voucher')}
								</Subtitle>
								<NormalText>
									{__('Recipient')}
									{': '}
									{this.props.giftVoucherData?.recipient_email}
								</NormalText>
								{this.props.giftVoucherData?.send_on_date && (
									<NormalText className="block">
										{__('Send date')}
										{': '}
										{moment(this.props.giftVoucherData?.send_on_date).format('LLLL')}
									</NormalText>
								)}
							</div>
							<Spacer size={2} />

							<OrderContent allergenError={this.state.allergenError} showAddItems={false} />
						</div>
					)}

				</div>


			</>
		);
	}
}

const mapItemsStateToProps = (store) => {
	const { basketUpdated, deliveryOption, giftVoucherData } = store.orders;
	const { auth, giftCards, profile } = store.profile;
	const { driverBookingPending, driverBookingMessage, voucherRemovedModalOpen, voucherAddedModalOpen } = store.common
	const { allergens } = store.restaurants
	return {
		basketUpdated,
		profile: store.profile.profile,
		cards: store.orders.cards || [],
		deliveryOption,
		itemAllergens: store.restaurants.itemAllergens,
		auth,
		giftVoucherData,
		taxCalculated: store.common.taxCalculated,
		taxContentLoading: store.common.taxContentLoading,
		giftCards: giftCards || [],
		vouchers: store.profile.vouchers || [],
		driverBookingPending,
		driverBookingMessage,
		voucherRemovedModalOpen,
		voucherAddedModalOpen,
		profile,
		allergens

	};
};

export const OrderSummaryItems = connect(mapItemsStateToProps)(withRouter(withTranslation(OrderSummaryItemsRaw)));